import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import styled from "styled-components";
import moment from "moment";
import lodash from 'lodash';

import FetchModule from "../../../Model/Network/FetchModule";
import useWindowSize from "../../Share/useWindowSize";
import TicketView from "../../Main/Model/TicketView";
import UserTicketView from "../Model/UserTicketView";

export default function TicketPage(props) {
  const { tournamentColumns, setTournamentColumns } = props;

  const params = useParams();

  const [isInProgress, setIsInProgress] = useState(false);
  const [isClickedModify, setIsClickedModify] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [originalTickets, setOriginalTickets] = useState([]);
  const [columnText, setColumnText] = useState('이벤트');
  const [refresh, setRefresh] = useState(false);

  // 사진 크기 // 
  const [mainPictureSize, setMainPictureSize] = useState(200);
  const [bannerPictureWidth, setBannerPictureWidth] = useState(343);
  const [bannerPictureHeight, setBannerPictureHeight] = useState(148);
  const [commonSouvenirWidth, setCommonSouvenirWidth] = useState(200);
  const [commonSouvenirHeight, setCommonSouvenirHeight] = useState(200);

  const [plusWidth, setPlusWidth] = useState(50);
  const [plusHeight, setPlusHeight] = useState(50);
  // 사진 크기 //

  const EditViewRef = useRef();

  const { width, height } = useWindowSize();

  const newTicketTemplate = {
    name: '',
    entryQualification: '',
    isUseSelectOption: false,
    // selectOptions: [],
    selectOptionGroups: [],
    isUseParticipantLimit: false,
    participantLimit: 0,
    teamMemberCount: 0,
    additionalInstructions: '',
    isUsePriceOption: false,
    priceOptions: [{
      id: 0,
      appliedDate: moment(),
      name: '',
      price: 0
    }],
    place: '',
    ticketThumbnail: ''
  };

  const newSelectOptionGroup = {
    id: 0,
    selectOptionGroupName: '',
    isRanked: false,
    isIndividualOption: false,
    selectOptions: []
  }

  const newSelectOption = {
    id: 0,
    name: '',
    selectOptionGroupId: 0
  }

  const newPriceOption = {
    id: 0,
    appliedDate: moment(),
    name: '',
    price: 0
  }

  // 사진 크기 결정 //
  useEffect(() => {
    let totalWidth = EditViewRef.current.offsetWidth < 607 ? EditViewRef.current.offsetWidth : 607;

    let mainPictureSize = parseInt(totalWidth * 0.3294) - 4;
    let bannerPictureWidth = parseInt(totalWidth * 0.565) - 4;
    let bannerPictureHeight = parseInt(bannerPictureWidth * 0.4314) - 4;
    let commonSouvenirWidth = parseInt(totalWidth * 0.3294) - 4;
    let commonSouvenirHeight = parseInt(commonSouvenirWidth * (1350 / 1080));

    let plusWidth = parseInt(totalWidth * 0.082);
    let plusHeight = parseInt(totalWidth * 0.009);

    setMainPictureSize(mainPictureSize);
    setBannerPictureWidth(bannerPictureWidth);
    setBannerPictureHeight(bannerPictureHeight);
    setCommonSouvenirWidth(commonSouvenirWidth);
    setCommonSouvenirHeight(commonSouvenirHeight);

    setPlusWidth(plusWidth);
    setPlusHeight(plusHeight);
  }, [EditViewRef, width])

  // API Call //
  useEffect(() => {
    let organizerId = parseInt(params.organizerId);

    if (organizerId !== 0) {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.getDataOfEventVer2('tournament/event/list/' + organizerId, 'GET');
          // console.log(responseData.data);
          if (responseData.status === 200) {
            let ticket = responseData.data.tickets.slice();

            for (let i = 0; i < ticket.length; i++) {
              for (let j = 0; j < ticket[i].priceOptions.length; j++) {
                ticket[i].priceOptions[j].appliedDate = moment(ticket[i].priceOptions[j].appliedDate);
              }
            }

            setOriginalTickets(lodash.cloneDeep(ticket));
            setTickets(ticket);
            setColumnText(responseData.data.columnText);
          }
        }
      )();
    }
  }, [params, refresh])

  // 이벤트 티켓 추가 클릭시 //
  function onClickAdditionTicket() {
    let newTickets = tickets.slice();

    newTickets.push(newTicketTemplate);

    setTickets(newTickets);
  }

  // 티켓 이름 수정시 //
  function onChangeAppliedTicketName(data, index) {
    let newTickets = tickets.slice();

    newTickets[index].name = data;

    setTickets(newTickets);
  }

  // 티켓 참가자격 수정시 //
  function onChangeAppliedEntryQualification(data, index) {
    let newTickets = tickets.slice();

    newTickets[index].entryQualification = data;

    setTickets(newTickets);
  }

  // 티켓 선택 옵션 사용여부 수정시 //
  function onChangeAppliedIsUseSelectOption(index) {
    let newTickets = tickets.slice();

    newTickets[index].isUseSelectOption = !newTickets[index].isUseSelectOption;

    setTickets(newTickets);
  }




  // 티켓 선택 옵션 그룹 추가시 //
  function onChangeAppliedAddSelectOptionGroup(index) {
    let newTickets = tickets.slice();

    newTickets[index].selectOptionGroups.push(newSelectOptionGroup);

    if (newTickets[index].selectOptionGroups.length === 1) {
      newTickets[index].selectOptionGroups[0].isRanked = true;
    }

    setTickets(newTickets);
  }

  // 티켓 선택 옵션 그룹 삭제시 //
  function onChangeAppliedDeleteSelectOptionGroup(index, selectOptionGroupIndex) {
    let newTickets = tickets.slice();
    let newSelectOptionGroups = newTickets[index].selectOptionGroups.slice();

    newSelectOptionGroups.splice(selectOptionGroupIndex, 1);
    newTickets[index].selectOptionGroups = newSelectOptionGroups;

    setTickets(newTickets);
  }

  // 티켓 선택 옵션 그룹 이름 변경시 //
  function onChangeAppliedSelectOptionGroupName(value, index, selectOptionGroupIndex) {
    let newTickets = tickets.slice();

    newTickets[index].selectOptionGroups[selectOptionGroupIndex].selectOptionGroupName = value;

    setTickets(newTickets);
  }

  // 티켓 선택 옵션 추가시 //
  function onChangeAppliedAddSelectOption(index, selectOptionGroupIndex) {
    let newTickets = tickets.slice();

    newTickets[index].selectOptionGroups[selectOptionGroupIndex].selectOptions.push(newSelectOption);

    setTickets(newTickets);
  }

  // 티켓 선택 옵션 삭제시 //
  function onChangeAppliedDeleteSelectOption(index, selectOptionGroupIndex, selectOptionIndex) {
    let newTickets = tickets.slice();
    let newSelectOptions = newTickets[index].selectOptionGroups[selectOptionGroupIndex].selectOptions.slice();

    newSelectOptions.splice(selectOptionIndex, 1);
    newTickets[index].selectOptionGroups[selectOptionGroupIndex].selectOptions = newSelectOptions;

    setTickets(newTickets);
  }

  // 티켓 선택옵션 참가자 개별 옵션 여부 정리 //
  function onChangeAppliedIsIndividualOption(index, selectOptionGroupIndex) {
    let newTickets = tickets.slice();

    newTickets[index].selectOptionGroups[selectOptionGroupIndex].isIndividualOption = !newTickets[index].selectOptionGroups[selectOptionGroupIndex].isIndividualOption;

    setTickets(newTickets);
  }

  // 티켓 선택 옵션 이름 변경시 //
  function onChangeAppliedSelectOptionName(data, index, selectOptionGroupIndex, selectOptionIndex) {
    let newTickets = tickets.slice();
    let newSelectOptions = newTickets[index].selectOptionGroups[selectOptionGroupIndex].selectOptions.slice();

    newSelectOptions[selectOptionIndex].name = data;
    newTickets[index].selectOptionGroups[selectOptionGroupIndex].selectOptions = newSelectOptions;

    setTickets(newTickets);
  }

  // 티켓 참가인원 제한 사용여부 변경시 //
  function onChangeAppliedIsUseParticipantLimit(index) {
    let newTickets = tickets.slice();

    newTickets[index].isUseParticipantLimit = !newTickets[index].isUseParticipantLimit;

    setTickets(newTickets);
  }

  // 티켓 참가인원 제한 변경시 //
  function onChangeAppliedParticipantLimit(data, index) {
    let newTickets = tickets.slice();

    newTickets[index].participantLimit = data

    setTickets(newTickets);
  }

  // 티켓 팀원 수 변경시 //
  function onChangeAppliedTeamMemberCount(data, index) {
    let newTickets = tickets.slice();

    newTickets[index].teamMemberCount = data

    setTickets(newTickets);
  }

  // 티켓 참가 추가지침 변경시//
  function onChangeAppliedAdditionalInstaructions(data, index) {
    let newTickets = tickets.slice();

    newTickets[index].additionalInstructions = data

    setTickets(newTickets);
  }

  // 티켓 가격 옵션 사용여부 변경시 //
  function onChangeAppliedIsUsePriceOption(index) {
    let newTickets = tickets.slice();

    newTickets[index].isUsePriceOption = !newTickets[index].isUsePriceOption;

    setTickets(newTickets);
  }

  // 티켓 가격 옵션 추가시 //
  function onChangeAppliedAddPriceOption(index) {
    let newTickets = tickets.slice();

    newTickets[index].priceOptions.push(newPriceOption);

    setTickets(newTickets);
  }

  // 티켓 가격 옵션 삭제시 //
  function onChangeAppliedDeletePriceOption(index, priceOptionIndex) {
    let newTickets = tickets.slice();
    let newPriceOptions = newTickets[index].priceOptions.slice();

    newPriceOptions.splice(priceOptionIndex, 1);
    newTickets[index].priceOptions = newPriceOptions;

    setTickets(newTickets);
  }

  // 티켓 가격 옵션 적용날짜 변경시 //
  function onChangeAppliedDeletePriceOption(index, priceOptionIndex) {
    let newTickets = tickets.slice();
    let newPriceOptions = newTickets[index].priceOptions.slice();

    if (newPriceOptions.length === 1) alert('기본 가격은 지울 수 없습니다');
    else {
      newPriceOptions.splice(priceOptionIndex, 1);
      newTickets[index].priceOptions = newPriceOptions;
    }

    setTickets(newTickets);
  }

  // 티켓 가격 옵션 적용날짜 변경시 //
  function onChangeAppliedPriceOptionAppliedDate(data, index, priceOptionIndex) {
    let newTickets = tickets.slice();
    let newPriceOptions = newTickets[index].priceOptions.slice();

    newPriceOptions[priceOptionIndex].appliedDate = data;
    newTickets[index].priceOptions = newPriceOptions;

    setTickets(newTickets);
  }

  // 티켓 가격 옵션 이름 변경시 //
  function onChangeAppliedPriceOptionName(data, index, priceOptionIndex) {
    let newTickets = tickets.slice();
    let newPriceOptions = newTickets[index].priceOptions.slice();

    newPriceOptions[priceOptionIndex].name = data;
    newTickets[index].priceOptions = newPriceOptions;

    setTickets(newTickets);
  }

  // 티켓 가격 옵션 가격 변경시 //
  function onChangeAppliedPriceOptionPrice(data, index, priceOptionIndex) {
    let newTickets = tickets.slice();
    let newPriceOptions = newTickets[index].priceOptions.slice();

    newPriceOptions[priceOptionIndex].price = data;
    newTickets[index].priceOptions = newPriceOptions;

    setTickets(newTickets);
  }

  // 티켓 대회 장소 변경시 //
  function onChangeAppliedPlace(data, index) {
    let newTickets = tickets.slice();

    newTickets[index].place = data;

    setTickets(newTickets);
  }

  // 티켓 가격 썸네일 변경시 //
  function onChangeAppliedTicketThumbnail(data, index) {
    let newTickets = tickets.slice();

    newTickets[index].ticketThumbnail = data;

    setTickets(newTickets);
  }

  // 티켓 삭제 클릭시 //
  function onClickAppliedDeleteTicket(index) {
    let newTickets = tickets.slice();

    if (newTickets.length > 1) {
      newTickets.splice(index, 1);
      setTickets(newTickets);
    }
    else setTickets([]);
  }

  // 취소하기 클릭시 //
  function onClickExit() {
    // setTitle(originalTitle);
    // setMainPicture(originalMainPicture);
    // setBannerPicture(originalBannerPicture);
    // setContent(originalContent);
    // setPeriod(originalPeriod);
    // setStartDate(originalStartDate);
    // setStartTime(originalStartTime);
    // setEndDate(originalEndDate);
    // setEndTime(originalEndTime);
    // setPlace(originalPlace);
    // setSubjectivity(originalSubjectivity);
    // setSponsor(originalSponsor);
    // setSupport(originalSupport);
    // setSouvenirPicture(originalSouvenirPicture);

    setTickets(originalTickets);
    setIsClickedModify(false);
  }

  // 저장하기 클릭시 //
  function onClickSave() {
    if (isClickedModify) {

      console.log(tickets);

      if (isInProgress) {
        alert('저장이 진행중입니다');
        return;
      }

      setIsInProgress(true);
      
      let finalTickets = lodash.cloneDeep(tickets);

      for (let i = 0; i < finalTickets.length; i++) {
        if (finalTickets[i].eventId === undefined) finalTickets[i].eventId = 0;
        
        for (let j = 0; j < finalTickets[i].priceOptions.length; j++) {
          finalTickets[i].priceOptions[j].appliedDate = finalTickets[i].priceOptions[j].appliedDate.format('YYYY-MM-DDT00:00:00');
        }
      }

      let requestData = {
        organizerId: parseInt(params.organizerId),
        tickets: finalTickets
      }
      // console.log(requestData);
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataOfEventVer2('event/save', 'POST', requestData);
          // console.log(responseData);
          if (responseData.status === 200) {
            setIsInProgress(false);
            setIsClickedModify(false);
            setRefresh(!refresh);
          }
          else {
            alert('저장에 실패했습니다\n잠시 후 다시시도해 주세요');
            setIsInProgress(false);
          }
        }
      )();
    }
    else setIsClickedModify(true);

    // setIsClickedModify(!isClickedModify);
  }

  return (
    <TopLevelWrapper>
      <TopComponentWrapper>
        <ColumnWrapper>
          <ColumnBox>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor='default'>{columnText}</Text>
          </ColumnBox>
          {/* <CopyButton>

          </CopyButton> */}
        </ColumnWrapper>
        <ButtonWrapper>
          <ExitButton isClicked={isClickedModify} onClick={onClickExit}>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor={isClickedModify ? 'pointer' : `default`}>취소하기</Text>
          </ExitButton>
          <SaveButton isClicked={isClickedModify} onClick={onClickSave}>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor='pointer'>{isClickedModify ? `저장하기` : `수정하기`}</Text>
          </SaveButton>
        </ButtonWrapper>
      </TopComponentWrapper>
      <TotalViewWrapper>
        <EditViewWrapper ref={EditViewRef}>
          <ViewBox>
            <TitleWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>이벤트 티켓 내용</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>티켓 이름, 참가 자격, 참가 지침, 참가비, 대회 장소, 티켓별 대표 이미지를 설정하세요</Text>
            </TitleWrapper>
            <TicketViewWrapper>
              {
                tickets.map((data, index) => (
                  <TicketView
                    key={'TicketView-' + index}
                    data={data}
                    index={index}
                    enabled={isClickedModify}

                    pictureSize={mainPictureSize}
                    plusWidth={plusWidth}
                    plusHeight={plusHeight}

                    onChangeAppliedTicketName={onChangeAppliedTicketName}
                    onChangeAppliedEntryQualification={onChangeAppliedEntryQualification}
                    onChangeAppliedIsUseSelectOption={onChangeAppliedIsUseSelectOption}
                    onChangeAppliedIsIndividualOption={onChangeAppliedIsIndividualOption}
                    onChangeAppliedAddSelectOptionGroup={onChangeAppliedAddSelectOptionGroup}
                    onChangeAppliedDeleteSelectOptionGroup={onChangeAppliedDeleteSelectOptionGroup}
                    onChangeAppliedSelectOptionGroupName={onChangeAppliedSelectOptionGroupName}
                    onChangeAppliedAddSelectOption={onChangeAppliedAddSelectOption}
                    onChangeAppliedDeleteSelectOption={onChangeAppliedDeleteSelectOption}
                    onChangeAppliedSelectOptionName={onChangeAppliedSelectOptionName}
                    onChangeAppliedIsUseParticipantLimit={onChangeAppliedIsUseParticipantLimit}
                    onChangeAppliedParticipantLimit={onChangeAppliedParticipantLimit}
                    onChangeAppliedTeamMemberCount={onChangeAppliedTeamMemberCount}
                    onChangeAppliedAdditionalInstaructions={onChangeAppliedAdditionalInstaructions}
                    onChangeAppliedIsUsePriceOption={onChangeAppliedIsUsePriceOption}
                    onChangeAppliedAddPriceOption={onChangeAppliedAddPriceOption}
                    onChangeAppliedDeletePriceOption={onChangeAppliedDeletePriceOption}
                    onChangeAppliedPriceOptionAppliedDate={onChangeAppliedPriceOptionAppliedDate}
                    onChangeAppliedPriceOptionName={onChangeAppliedPriceOptionName}
                    onChangeAppliedPriceOptionPrice={onChangeAppliedPriceOptionPrice}
                    onChangeAppliedPlace={onChangeAppliedPlace}
                    onChangeAppliedTicketThumbnail={onChangeAppliedTicketThumbnail}
                    onClickAppliedDeleteTicket={onClickAppliedDeleteTicket}
                  />
                ))
              }
            </TicketViewWrapper>
            {
              isClickedModify &&
              <TicketAdditionButtonWrapper>
                <TicketAdditionButton onClick={onClickAdditionTicket}>
                  <PlusWrapper>
                    <PlusStick width={24} height={3} />
                    <PlusStick width={3} height={24} />
                  </PlusWrapper>
                  <Text fontFamily='NotoSansKR-Bold' fontSize={20} color='#FFFFFF' cursor='pointer'>이벤트 티켓 추가</Text>
                </TicketAdditionButton>
              </TicketAdditionButtonWrapper>
            }
          </ViewBox>
        </EditViewWrapper>
        <UserViewWrapper>
          <UserTicketView tickets={tickets}/>
        </UserViewWrapper>
      </TotalViewWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 100%;
`;

const TopComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const CopyButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 40px;
  height: 40px;

  border-radius: 8px;
  background-color: #6DD49E;

  :hover {
    cursor: pointer;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 92px;
  height: 40px;

  border-radius: 8px;
  background-color: #969696;

  opacity: ${props => props.isClicked ? 1 : 0};

  :hover {
    cursor: ${props => props.isClicked ? `pointer` : `default`};
  }

  transition: all 0.3s ease-in-out;
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 92px;
  height: 40px;

  border-radius: 8px;
  background-color: ${props => props.isClicked ? `#6DD49E` : `#969696`};

  :hover {
    cursor: pointer;

    background-color: #6DD49E;
  }

  transition: all 0.3s ease-in-out;
`;

const ColumnBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  min-width: 92px;
  height: 40px;

  border-radius: 8px;
  background-color: #6DD49E;

  :hover {
    cursor: default;
  }

  transition: all 0.3s ease-in-out;
`;

const TotalViewWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 20px;

  width: 100%;
  height: calc(100% - 63px);
`;

const EditViewWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 61%;
  height: 100%;

  gap: 10px;

  overflow: scroll;

  &::-webkit-scrollbar {
    width: 2px;
    height: 0px;
  }
  
  &::-webkit-scrollbar-thumb {
    border: 2px solid transparent;
    background-color: #FFFFFF;
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-track {
    border-radius: 200px;
    opacity: 0;
  }
`;

const UserViewWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 37%;
  // height: calc(100% - 63px);
  height: 100%;

  gap: 10px;

  overflow: scroll;

  &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
  
    &::-webkit-scrollbar-thumb {
    	border: 2px solid transparent;
    	background-color: #FFFFFF;
    	border-radius: 2px;
    }
  
    &::-webkit-scrollbar-track {
    	// background-color: #F9F9F9;
    	border-radius: 200px;
      opacity: 0;
    }
`;

const ViewBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 20px 0px;

  width: 98%;

  border-radius: 20px;
  background-color: #17171B;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 93.81%;

  gap: 4px;
`;

const TicketViewWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;

  gap: 34px;
`;

const TicketAdditionButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 34px;

  width: 93.81%;
`;

const TicketAdditionButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 102px;

  gap: 12px;

  border-radius: 5px;
  background-color: #6DD49E;

  :hover {
    cursor: pointer;
  }
`;

const PlusWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;
`;

const PlusStick = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: 8px;
  background-color: #FFFFFF;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  :hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;